import { Amplify } from 'aws-amplify';

import { environment } from './environments/environment';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.awsUserPoolId,
      userPoolClientId: environment.awsUserPoolClientId,
      userPoolEndpoint: `https://${environment.awsCognitoDomain}`,
    },
  },
});
